<!--导出字段勾选组件-->
<template>
    <div>
        <el-dialog title="添加已有应用" :visible.sync="appFormVisible" :before-close="handleClose">
            <el-row class="row-bg" :gutter="10" v-for="(item, index) in app_list" :key="item.type">
                <div class="header-contain">
                    <p>{{ item.name }}</p>
                </div>
                <el-col :span="3" v-for="(child, child_index) in item.childs" :key="child.app_id">
                    <div class="grid-content">
                        <img 
                        class="grid-image"
                        :src="child.homeIcon"
                        @click="imageClick(child, index, child_index)"
                        >
                        <br>
                        <el-tooltip :content="child.app_name" placement="bottom">
                            <div class="ellipsis">{{ child.app_name }}</div>
                        </el-tooltip>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<style scoped>
.grid-content {
   text-align: center;
}
.grid-image {
    width: 45px; 
    height: 45px;
    border-radius: 15%;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.row-bg {
    padding: 10px 0;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: 0; /* 默认情况下不可见 */
  transition: opacity 0.3s ease; /* 添加渐变效果 */
  /* ... 其他样式 ... */
  background-color: rgba(0, 0, 0, 0.5); /* 添加不透明背景 */
}
.icon {
  font-size: 36px;
  color: white;
}
.overlay.active {
  opacity: 1; /* 当鼠标聚焦时可见 */
}
  
</style>
  
  <script>
  import CommonService from "~/services/common";
  export default {
    name: "AppDialog",
    props: {
        display: {
            type: Boolean,
            required: true,
        },
        check_list: {
            type: Array,
            required: true,
        },
    },
    data() {
      return {
        //定义变量
        loading: true,
        appFormVisible: false,
        app_list:  [
            // {
            //     "name": "基础配置应用",
            //     "type": 1,
            //     "childs": [
            //         {
            //             "app_id": 64,
            //             "app_name": "基础数据",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 1,
            //             "type_name": "基础配置应用",
            //             "config": {
            //                 "app_id": 64,
            //                 "app_name": "基础数据",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 78,
            //             "app_name": "数据中心",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 1,
            //             "type_name": "基础配置应用",
            //             "config": {
            //                 "app_id": 78,
            //                 "app_name": "数据中心",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         }
            //     ]
            // },
            // {
            //     "name": "教务管理应用",
            //     "type": 2,
            //     "childs": [
            //         {
            //             "app_id": 6,
            //             "app_name": "校本资源库",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 6,
            //                 "app_name": "校本资源库",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 7,
            //             "app_name": "在线组卷",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 7,
            //                 "app_name": "在线组卷",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 23,
            //             "app_name": "二一微课堂",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 23,
            //                 "app_name": "二一微课堂",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 26,
            //             "app_name": "在线备课",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 26,
            //                 "app_name": "在线备课",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 28,
            //             "app_name": "作业系统",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 28,
            //                 "app_name": "作业系统",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 34,
            //             "app_name": "新校本资源库",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 34,
            //                 "app_name": "新校本资源库",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 38,
            //             "app_name": "在线题库",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 38,
            //                 "app_name": "在线题库",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 42,
            //             "app_name": "二一阅卷",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 42,
            //                 "app_name": "21阅卷",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 48,
            //             "app_name": "在线选课",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 48,
            //                 "app_name": "在线选课",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 50,
            //             "app_name": "选排课（内测版）",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 50,
            //                 "app_name": "选排课（内测版）",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 58,
            //             "app_name": "二一资源",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 58,
            //                 "app_name": "二一资源",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 65,
            //             "app_name": "题卡中心",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 65,
            //                 "app_name": "题卡中心",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 79,
            //             "app_name": "电子班牌",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 2,
            //             "type_name": "教务管理应用",
            //             "config": {
            //                 "app_id": 79,
            //                 "app_name": "电子班牌",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         }
            //     ]
            // },
            // {
            //     "name": "教学备课应用",
            //     "type": 3,
            //     "childs": [
            //         {
            //             "app_id": 1,
            //             "app_name": "人事管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 1,
            //                 "app_name": "人事管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 2,
            //             "app_name": "学籍管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 2,
            //                 "app_name": "学籍管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 3,
            //             "app_name": "教师成长档案",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 3,
            //                 "app_name": "教师成长档案",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 4,
            //             "app_name": "成绩管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 4,
            //                 "app_name": "成绩管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 12,
            //             "app_name": "考勤管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 12,
            //                 "app_name": "考勤管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 14,
            //             "app_name": "公告管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 14,
            //                 "app_name": "公告管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 16,
            //             "app_name": "评价管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 16,
            //                 "app_name": "评价管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 17,
            //             "app_name": "绩效管理",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 17,
            //                 "app_name": "绩效管理",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 20,
            //             "app_name": "学校门户",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 20,
            //                 "app_name": "学校门户",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 27,
            //             "app_name": "学生综合素质评价",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 27,
            //                 "app_name": "学生综合素质评价",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 46,
            //             "app_name": "课表查询",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 46,
            //                 "app_name": "课表查询",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 60,
            //             "app_name": "新综合素质评价",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 60,
            //                 "app_name": "新综合素质评价",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 63,
            //             "app_name": "人脸识别",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 63,
            //                 "app_name": "人脸识别",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 66,
            //             "app_name": "教学评价",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 66,
            //                 "app_name": "教学评价",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         },
            //         {
            //             "app_id": 76,
            //             "app_name": "教学评价",
            //             "is_recommend": false,
            //             "image": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            //             "type": 3,
            //             "type_name": "教学备课应用",
            //             "config": {
            //                 "app_id": 76,
            //                 "app_name": "教学评价",
            //                 "is_open": true,
            //                 "time": [],
            //                 "number": 15
            //             }
            //         }
            //     ]
            // }
        ],
        check_ids: [],
        appButtonLoading: false,
        showOverlay: false
      };
    },
  
    created: function () {
        this.appFormVisible = this.display;
        this.check_ids = this.check_list;
        this.getAppList();
        this.refreshCheckIds();
    },

    methods: {
        close() {
            this.appFormVisible = false;
            this.$emit("closeAppDialog");
        },

        handleClose() {
            this.close();
        },

        refreshCheckIds(){
            // 使用filter方法过滤掉指定的子数组
            this.app_list = this.app_list.map(item => {
                // 使用filter方法过滤子数组中的app_id
                item.childs = item.childs.filter(app => !this.check_ids.includes(app.app_id));
                return item;
            });
        },
        getAppList(){
            //加载产品列表
            CommonService.getAllAPP({is_type: 1}).then(res => {
                if (res.code == 0) {
                    this.app_list = res.data;
                    this.refreshCheckIds();
                }else{
                    this.$message({
                    message: res.msg,
                    type: 'error'
                    })
                    return false;
                }
            });
        },
        imageClick(child, index, child_index){
            this.check_ids.push(child.app_id);
            this.refreshCheckIds();
            this.$message({
                message: '添加成功',
                type: 'success'
            })
            this.$emit("clickAppDialog", child);
        }
    }
  };
  </script>


// WEBPACK FOOTER //
// src/views/order/digitizedcampus/AppDialog.vue